import { validateJson } from '@pypestream/pif-compiler-language';

export type DiagnosticCode = unknown;

export type Diagnostic = {
  code?: string | number | DiagnosticCode;
  codeDescription?: string;
  data?: {
    id?: string;
    nodeNumber?: string;
    propertyName?: string;
  };
  message: string;
  severity?: number;
  range: {
    start: { line: number | null; character: number | null };
    end: { line: number | null; character: number | null };
  };
  relatedInformation?: unknown;
  source?: string;
  tags?: unknown;
};

export const compileJson = async (data: string): Promise<Diagnostic[]> => {
  try {
    const result = await validateJson(data);
    return result as Diagnostic[];
  } catch (error) {
    console.error('Error compiling JSON:', error);
    const diagnostics: Diagnostic[] = [
      {
        severity: 1,
        range: {
          start: { line: 0, character: 0 },
          end: { line: 0, character: 0 },
        },
        message: (error as Error).message,
        data: {},
        source: 'pypestream-pif',
        code: 'parsing-error',
      },
    ];

    return diagnostics;
  }
};
